import BreakpointsService, {
    BreakpointMinSizes,
} from "@services/breakpoint.service";

export const determineSlidesPerView = (breakpoints: any) => {
    const breakPointsSettings: any = {};
    breakpoints.map((breakpoint: any) => {
        breakPointsSettings[
            BreakpointsService.getBreakpointMinValues(breakpoint.breakpoint)
        ] = {
            direction: breakpoint.direction,
            slidesPerView: breakpoint.slides,
        };
    });

    return breakPointsSettings;
};

/**
 * Parse the settings to JSON
 * Replace the breakpoint aliases with the actual breakpoint values
 * @param originalSettings
 * @returns {null|*}
 */
export const getBreakPointLayoutSettings = (
    originalSettings: any,
): null | any => {
    if (!originalSettings) {
        return null;
    }
    let parsedSettings: any = null;
    // Parse the settings
    if (typeof originalSettings === "string") {
        parsedSettings = JSON.parse(originalSettings);
    } else if (typeof originalSettings === "object") {
        parsedSettings = originalSettings;
    }
    // Replace the aliases with the breakpoint values
    return Object.assign(
        // @ts-ignore
        ...Object.keys(parsedSettings).map((k: string) => ({
            [BreakpointsService.getBreakpointMinValues(
                k as BreakpointMinSizes,
            )]: parsedSettings[k],
        })),
    );
};

export const determineSlidesPerViewByObject = (breakpoints: any) => {
    const breakPointsSettings: any = {};
    if (breakpoints) {
        Object.keys(breakpoints).map(key => {
            breakPointsSettings[key] = {
                slidesPerView: breakpoints[key].slidesPerView,
            };
        });
    }

    return breakPointsSettings;
};

export const mapSsrLayoutClasses = (breakpointsLayoutSettings: {
    [key: string]: {
        slidesPerView: number;
    };
}) => {
    return Object.keys(breakpointsLayoutSettings)
        .reduce((acc: string[], current: string) => {
            acc.push(
                `slider-layout-${current}-${breakpointsLayoutSettings[
                    current
                ]?.slidesPerView
                    .toString()
                    .replace(".", "_")}`,
            );
            return acc;
        }, [])
        .join(" ");
};

export default determineSlidesPerView;
